import useNavigationStore from "@src/stores/navigationStore";
import LCBFT from "./LCBFT";
import LatestResults from "./LatestResults";
import Informations from "./Informations";

const componentMap = {
    LCBFT: LCBFT,
    LatestResults: LatestResults,
    Informations: Informations
};

export default function FourthSection() {
    const { section } = useNavigationStore();

    const SelectedComponent = componentMap[section.block as keyof typeof componentMap] || null;

    return <>{SelectedComponent ? <SelectedComponent /> : null}</>;
}
